/*************************************************/
/* EMPLOYEES                                     */
/*************************************************/

export function employees() {

    const init = () => {
        const employeeGroups = document.querySelectorAll('.employee-items');

        employeeGroups.forEach(group => {
            const toggleButtons = group.querySelectorAll('.employee-item__bio-toggle');

            toggleButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const targetId = button.getAttribute('data-target');
                    const bioElement = document.getElementById(targetId);
                    const isExpanded = button.getAttribute('aria-expanded') === 'true';
                    const readMoreText = button.getAttribute('data-readmore');
                    const readLessText = button.getAttribute('data-readless');

                    // Close all other bios in this group
                    toggleButtons.forEach(otherButton => {
                        const otherId = otherButton.getAttribute('data-target');
                        const otherBio = document.getElementById(otherId);
                        if (otherButton !== button) {
                            otherButton.setAttribute('aria-expanded', 'false');
                            otherButton.textContent = otherButton.getAttribute('data-readmore');
                            if (otherBio) {
                                otherBio.style.maxHeight = '0px';
                                otherBio.classList.remove('is-expanded');
                            }
                        }
                    });

                    // Toggle current bio
                    if (!isExpanded) {
                        bioElement.style.maxHeight = bioElement.scrollHeight + 'px';
                        bioElement.classList.add('is-expanded');
                        button.setAttribute('aria-expanded', 'true');
                        button.textContent = readLessText;
                    } else {
                        bioElement.style.maxHeight = '0px';
                        bioElement.classList.remove('is-expanded');
                        button.setAttribute('aria-expanded', 'false');
                        button.textContent = readMoreText;
                    }
                });
            });
        });
    };

    init();
}
